var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 3.33333H8.33268",
    stroke: "#714FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 10.0003H9.33268",
    stroke: "#714FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66644 3.33301V7.33301L11.1164 11.5793C11.4704 12.0149 11.1604 12.6663 10.599 12.6663H1.40035C0.83899 12.6663 0.52895 12.0149 0.882944 11.5793L4.3331 7.33301V3.33301",
    stroke: "#714FFF",
    strokeWidth: 1.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99935,
    cy: 1.66634,
    rx: 0.333333,
    ry: 0.333333,
    fill: "#714FFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.99935,
    cy: 0.333333,
    rx: 0.333333,
    ry: 0.333333,
    fill: "#714FFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.33268,
    cy: 1.99967,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerName);
export default __webpack_public_path__ + "static/media/partner-name.48f4a910f31e55a31fac50e73ec81b62.svg";
export { ForwardRef as ReactComponent };